<template>
  <div id="price-management">
    <vx-card title="Soßenpreise" class="mb-6" v-if="uniqueSauces.length">
      <vs-table :data="uniqueSauces">
        <template slot="thead">
          <vs-th>Soße</vs-th>
          <vs-th>Preis (€)</vs-th>
          <vs-th></vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="sauce in data" :key="sauce.name">
            <vs-td>{{ sauce.name }}</vs-td>
            <vs-td>
              <vs-input
                type="number"
                step="0.01"
                min="0"
                v-model="saucePrices[sauce.name]"
                class="w-24"
              />
            </vs-td>
            <vs-td>
              <vs-button
                size="small"
                @click="saveSaucePrice(sauce.name)"
                :disabled="saucePrices[sauce.name] == sauce.price"
              >
                Speichern
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vx-card
      v-for="(products, category) in productsByCategory"
      :key="category"
      :title="category"
      class="mb-6"
    >
      <vs-table :data="products">
        <template slot="thead">
          <vs-th>Produkt</vs-th>
          <vs-th>Preis (€)</vs-th>
          <vs-th></vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="product in data" :key="product._id">
            <vs-td>{{ product.title }}</vs-td>
            <vs-td>
              <vs-input
                type="number"
                step="0.01"
                min="0"
                v-model="prices[product._id]"
                class="w-24"
              />
            </vs-td>
            <vs-td>
              <vs-button
                size="small"
                @click="savePrice(product._id)"
                :disabled="prices[product._id] == product.price"
              >
                Speichern
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      prices: {},
      saucePrices: {},
    };
  },
  computed: {
    productsByCategory() {
      return this.$store.getters["products/productsByCategory"];
    },
    uniqueSauces() {
      return this.$store.getters["products/uniqueSauces"];
    },
  },
  watch: {
    productsByCategory: {
      immediate: true,
      handler(categories) {
        if (!categories) return;
        Object.values(categories)
          .flat()
          .forEach((p) => {
            if (this.prices[p._id] === undefined) {
              this.$set(this.prices, p._id, p.price);
            }
          });
      },
    },
    uniqueSauces: {
      immediate: true,
      handler(sauces) {
        if (!sauces) return;
        sauces.forEach((s) => {
          if (this.saucePrices[s.name] === undefined) {
            this.$set(this.saucePrices, s.name, s.price);
          }
        });
      },
    },
  },
  created() {
    this.$store.dispatch("products/fetchProducts");
  },
  methods: {
    async savePrice(productId) {
      const price = parseFloat(this.prices[productId]);
      if (isNaN(price) || price < 0) {
        this.$vs.notify({
          title: "Fehler",
          text: "Ungültiger Preis.",
          color: "danger",
        });
        return;
      }
      try {
        await this.$store.dispatch("products/updateProductPrice", {
          productId,
          price,
        });
        this.$vs.notify({
          title: "Gespeichert",
          text: "Preis aktualisiert.",
          color: "success",
        });
      } catch (error) {
        this.$vs.notify({
          title: "Fehler",
          text: "Konnte nicht gespeichert werden.",
          color: "danger",
        });
      }
    },
    async saveSaucePrice(sauceName) {
      const price = parseFloat(this.saucePrices[sauceName]);
      if (isNaN(price) || price < 0) {
        this.$vs.notify({
          title: "Fehler",
          text: "Ungültiger Preis.",
          color: "danger",
        });
        return;
      }
      try {
        await this.$store.dispatch("products/updateSaucePrice", {
          sauceName,
          price,
        });
        this.$vs.notify({
          title: "Gespeichert",
          text: `Preis für "${sauceName}" aktualisiert.`,
          color: "success",
        });
      } catch (error) {
        this.$vs.notify({
          title: "Fehler",
          text: "Konnte nicht gespeichert werden.",
          color: "danger",
        });
      }
    },
  },
};
</script>

<style scoped>
::v-deep input[type="number"]::-webkit-outer-spin-button,
::v-deep input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
::v-deep input[type="number"] {
  -moz-appearance: textfield;
}
</style>
